const LOGO_IMAGE = 'https://static.lumi.new/90/90780d3e0e5e5c46f70ed4649948fe40.webp'

function Footer() {
  return (
    <footer className="bg-zinc-950 border-t border-zinc-800 py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col items-center justify-center text-center">
        <img
          src={LOGO_IMAGE}
          alt="MR.EAR 耳朵先生 The Taste Of... 限定收藏香氛"
          className="h-[90px] md:h-[108px] lg:h-[115px] w-auto mx-auto mb-10"
          style={{ background: 'transparent', border: 'none', boxShadow: 'none', padding: 0, display: 'block', filter: 'none' }}
        />

        <div className="space-y-1.5" style={{ textAlign: 'center' }}>
          <p className="text-xs text-stone-500">台北市南港區忠孝東路七段99號產業區三樓</p>
          <p className="text-xs text-stone-500">
            Email：info@mrearmusic.com ｜ Phone：02-77094888
          </p>
          <p className="text-xs text-stone-600 pt-1">
            ©
            {' '}
            {new Date().getFullYear()}
            {' '}
            MR.EAR. ALL RIGHTS RESERVED.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
